import React from 'react';
import FormInput from 'components/Input/FormInput';
import { useTranslation } from 'react-i18next';

interface IDescriptionField {
	changeDescription: (value: string) => void;
}

const DescriptionField: React.FC<IDescriptionField> = ({ changeDescription }) => {
	const { t } = useTranslation('error');

	return (
		<FormInput
			testId="DescriptionField"
			name="description"
			label="descriptionLabel"
			type="textArea"
			onChange={changeDescription}
		/>
	);
};

export default React.memo(DescriptionField);
